module.exports = __webpack_public_path__ + "img/qrcode_ygxcx.d44194bc.jpg";